import React from "react";
import { BUSINESS } from "@/data/site";

// WhatsApp deep link (digits only, no + or spaces)
const WHATSAPP_NUMBER = "5016395057";
const MESSAGE = encodeURIComponent("Hi Crawford Construction, I'd like to request a quote for my project.");

export const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-[70] group flex items-center gap-3"
    >
      <span className="hidden sm:block bg-navy text-white text-sm font-semibold px-4 py-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Chat on WhatsApp
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-xl transition-transform duration-300 group-hover:scale-110">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <svg viewBox="0 0 32 32" className="h-8 w-8 fill-white relative">
          <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.593 4.463 1.72 6.404L3.2 28.8l6.57-1.72a12.74 12.74 0 006.234 1.588h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.053A12.72 12.72 0 0016.004 3.2zm0 23.04h-.004a10.62 10.62 0 01-5.41-1.48l-.388-.23-4.02 1.053 1.073-3.92-.253-.402a10.6 10.6 0 01-1.626-5.663c0-5.867 4.774-10.64 10.644-10.64 2.843 0 5.514 1.108 7.523 3.12a10.57 10.57 0 013.118 7.526c0 5.867-4.774 10.64-10.63 10.64zm5.834-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.951-.848-1.593-1.896-1.78-2.216-.187-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.734-.986-2.374-.26-.624-.523-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.667 0 1.573 1.146 3.093 1.306 3.307.16.213 2.253 3.44 5.46 4.823.763.33 1.358.527 1.822.674.766.244 1.463.21 2.014.127.615-.092 1.892-.773 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/>
        </svg>
      </span>
    </a>
  );
};
